import type { BillingCycle } from '../lib/plan';

const CYCLE_OPTIONS: readonly { value: BillingCycle; label: string }[] = [
  { value: 'monthly', label: 'Mensual' },
  { value: 'annual', label: 'Anual' },
];

type BillingCycleToggleProps = {
  value: BillingCycle;
  onChange: (cycle: BillingCycle) => void;
  /** Whole percent the year up front takes off. */
  discountPct: number;
  disabled?: boolean;
  /**
   * 'note' (the default) states the saving in a line beside the switch;
   * 'bubble' puts "Ahorra 20%" inside the Anual segment, for signup's plan step.
   */
  savings?: 'note' | 'bubble';
};

/**
 * Mensual / Anual above a plan list. Shared by signup, the owner's Membresía
 * and the admin's business detail, so the two ways to pay read the same
 * everywhere. The saving is stated as a percentage, never as free months.
 */
export function BillingCycleToggle({ value, onChange, discountPct, disabled, savings = 'note' }: BillingCycleToggleProps) {
  const bubble = savings === 'bubble';
  return (
    <div className="billing-cycle" data-savings={savings}>
      <div className="seg" role="group" aria-label="Forma de pago">
        {CYCLE_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            disabled={disabled}
            onClick={() => onChange(option.value)}
          >
            {option.label}
            {bubble && option.value === 'annual' ? (
              <span className="save-bubble">Ahorra {discountPct}%</span>
            ) : null}
          </button>
        ))}
      </div>
      {bubble ? null : <p className="billing-cycle-note">Paga el año completo y ahorras {discountPct}%.</p>}
    </div>
  );
}
